<template>
		<div class="carousel-box bottom-padding overflow">
			<div class="title-box no-margin">
			<h1 class="title">Order Confirmation</h1>
      <p>Please confirm the order details before shopping.</p>
			</div>
			
			<div class="clearfix"></div>
			
			<div class="row">
        <article class="content span12">
            <div class="table-box">
                <table id="shopping-cart-table" class="shopping-cart-table table table-bordered table-striped">
                <thead>
                    <tr>
                <th></th>
                <th class="td-name">Item</th>
                <th class="td-qty">Pcs</th>
                    </tr>
                </thead>
                <tbody>
                
                
                  <tr v-if="results.Cart.length<=0">
                      <td colspan="3">Your shopping cart is enpty!</td>
                  </tr>
                    <tr v-for="result in results.Cart" :key="result.id">
                <td class="td-images">
                
                    <img :src="result.image_path" :alt="result.title"  :title="result.title" width="70" height="70">
                </td>
                <td class="td-name">
                    <h2 class="product-name">
                    {{result.title}} [{{result.category_name}}]
                    <br><strong>Weight:</strong> {{result.weight}}
                    <span v-if="result.size != ''"><br><strong>Size:</strong> {{result.size}}</span>
                    </h2>

                </td>

                <td class="td-qty">
                  <span class="price">{{result.qty}}</span>
                </td>
                    </tr>
                                    </tbody>
                </table><!-- .shopping-cart-table -->
            </div>
            <table class="shopping-cart-table shopping-cart-table-button table table-bordered table-striped">
                <tbody>
                  <tr>
                <td class="action">
                  <br>
                    <span class="pull-left"><h6 class="title">Pcs: {{CountTotalPcs()}}</h6></span><span class="pull-right"><h6> Total Weight: {{CountTotalWeight()}}</h6></span>

                </td>
                </tr>
                  <tr>
                <td class="action">
                  <br>
                    <h6 class="title">Special Instructions:</h6>
                  <textarea v-model="results.specialize_instructions" id="instructions" name="instructions" cols="80" rows="5" class="input-block-level"></textarea>
                </td>
                </tr>
            </tbody></table>            
            
            <div id="car-bottom" class="row">
                   <button type="button" v-on:click="placeOrder()" v-if="Session.is_login" id="btnPlaceOrder" class="btn btn-large checkout pull-right">Place Order</button>
                   <router-link to="/login/?f=checkout" v-if="!Session.is_login" class="btn btn-large checkout pull-right">Place Order</router-link>
            </div>

            <div class="clesrfix"></div>
            <br><br><br><br>

        </article>
			</div>
		</div>
</template>
<script>
//import axios from 'axios'
import Vue from 'vue'
import $ from 'jquery'
import Common from '@/common.js'
import OnLoad from 'vue-onload'
import Vue2TouchEvents from 'vue2-touch-events'
import {mapGetters, mapActions} from "vuex";
import EventBus from '@/EventBus.js'
//import { bus } from '@/main.js'

Vue.use(OnLoad);
Vue.use(Vue2TouchEvents)



export default {
	name:'OrderReviewList',
   data: function(){
    return {
    results: {specialize_instructions:"",Cart:{},cart_count:"0"}
    }
  },  props: {
    msg: String
  },mounted: function() {

    //alert(this.$route.params.categoryId);
    this.loadOnMount();

    
    //axios.get("http://localhost/api/categories.php")
    //.then(response => {this.results = response.data})
    
  },created(){
    this.getSession;
    this.getCart;
    this.removeFromCart;
EventBus.$on('placeOrder', () => {
  this.placeOrder();
})    
},
  computed:mapGetters(["Cart","CartCount","Session"]),
    watch:{
    Cart(newValue) {this.get_response(newValue)  },
    CartCount(newValue) { this.results.cart_count = newValue  },
    Session(newValue) {  
      if(newValue.is_login)
       {
         this.get_response(this.getCart());
       }else
       {
         Common.startAjaxLoader();
         this.$router.push('/login/?f=checkout')
       }      
     },
    $route() {
      this.get_response(this.getCart());
      
    }
  },methods:{
          ...mapActions(["getSession","getCart"]),
          loadOnMount: function()
          {

            Common.stopAjaxLoader();
            this.getSession();
              //Common.callServerFunction("Items/ItemController::GetCategoryItems",this.get_response,{'category':this.$route.params.categoryId},"Item");
          },
          placeOrder: function(){
            Common.callServerFunction("Orders/OrderController::PlaceOrder",this.get_order_response,{'specialize_instructions':this.results.specialize_instructions},"Orders");
          },
          touchHandler (event) {
            
            var purl =  $(event.target).attr('href');
            if(purl != undefined)
            {
              this.$router.push(purl);
            }else
            {
              purl = $(event.target).parent().attr('href');
              this.$router.push(purl);
            }

            //console.log($(event.target).parent())  // May be left / right / top / bottom
        },
        get_order_response:function(response)
        {
          var rdata = JSON.parse(response);
          this.getCart();
          //alert(rdata.order_id);
            if(rdata.order_id)
            {
              this.$router.push('/thankyou/?oid=' + rdata.order_id);
            }
        },
        CountTotalWeight:function()
        {
          var total_weight = 0;
          if(this.results.Cart.length > 0){
                this.results.Cart.forEach((item) => {
                   total_weight = parseFloat(total_weight) + parseFloat(item.weight);
                });
          }
          return total_weight;
        },CountTotalPcs:function()
        {
          var total_pcs = 0;
          
          if(this.results.Cart.length > 0){
                this.results.Cart.forEach((item) => {
                   total_pcs = parseFloat(total_pcs) + parseFloat(item.qty);
                });
          }
          return total_pcs;
        },
          get_response:function(response)
          {	
            //var rdata = JSON.parse(response);
            var rdata = response;
            this.results.Cart = response;
                var jimage = [];
                
                if(this.CartCount<=0)
                {
                  Common.showWarning("Your shopping cart is empty!");
                  this.$router.push("/cart");
                  return;
                }

                if(rdata.length > 0){
                  Common.startAjaxLoader();
                rdata.forEach((item) => {
                    //console.log(item.image_path + " - " + index);
                    jimage.push(item.image_path)
                });
                
                this.preload = false
                this.$nextTick(function() {
                  this.$images.preload(jimage,
                  (completed) => {
                    //(completed, progress) => {
                      // progress indicator from 0 (no image loaded yet) to 1 (all images loaded)
                      //console.log(Math.round(progress * 100))
                      // completed = true when all images are loaded
                      if (completed) {
                        this.preload = true
                        //console.log(completed);
                        eval('loadFunctions();');
                        Common.stopAjaxLoader();
                      }
                    }
                  )
                })

                //$(".item").eq(0).addClass('item active');


                          //$.get('./js/main.js', function(data) {
                        //eval(data);
                        //eval('setTimeout(loadFunctions(),1000);');

                //});
              }    
                
         }   
   }  
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
